import axios from 'axios';
import {
  API_KEY_LIST_REQUEST,
  API_KEY_LIST_SUCCESS,
  API_KEY_LIST_FAIL,
  API_KEY_CREATE_REQUEST,
  API_KEY_CREATE_SUCCESS,
  API_KEY_CREATE_FAIL,
  API_KEY_DELETE_REQUEST,
  API_KEY_DELETE_SUCCESS,
  API_KEY_DELETE_FAIL,
} from '../constants/apiKeyConstants';

// List all API keys. `background: true` fetches silently — no spinner, and a failure leaves the
// current keys alone.
export const listApiKeys = ({ background = false } = {}) => async (dispatch, getState) => {
  try {
    if (!background) dispatch({ type: API_KEY_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get('/api/apikeys', config);

    dispatch({
      type: API_KEY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (background) return;
    dispatch({
      type: API_KEY_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create a new API key
export const createApiKey = (apiKeyData) => async (dispatch, getState) => {
  try {
    dispatch({ type: API_KEY_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post('/api/apikeys', apiKeyData, config);

    dispatch({
      type: API_KEY_CREATE_SUCCESS,
      payload: data,
    });

    // Refresh the list after creating a new key
    dispatch(listApiKeys());
  } catch (error) {
    dispatch({
      type: API_KEY_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete an API key
export const deleteApiKey = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: API_KEY_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/apikeys/${id}`, config);

    dispatch({
      type: API_KEY_DELETE_SUCCESS,
    });

    // Refresh the list after deleting a key
    dispatch(listApiKeys());
  } catch (error) {
    dispatch({
      type: API_KEY_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};